import find from 'lodash/find';
import size from 'lodash/size';
import { Events } from '../../../types/index';

//This should be ported over to use selector model
//Receives entity object from state
export const hasEventResults = (results: any) => {
    const eventResults = find(results, ({ type }) => type === 'event') || {};

    return !!size(eventResults.content);
};

/**
 * @name hasSameEvents
 * @description extracts event ids from supplied arrays of event objects,
 * flattents the arrays to strings and performs a strict comparison, returning
 * a boolean indicating whether the two match
 * @param {obj} prevEvents the previous event set, e.g. `prevProps.events`
 * @param {obj} events the current event set, e.g. `this.props.events`
 * @returns {boolean}
 */
export const hasSameEvents = (prevEvents: Events, events: Events) => {
    const prevEventsArr: any[] = [];
    const eventsArr: any[] = [];

    prevEvents.map((event) => {
        prevEventsArr.push(event.id);
    });

    events.map((event) => {
        eventsArr.push(event.id);
    });

    return prevEventsArr.toString() === eventsArr.toString();
};
